import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/toPromise';

import { Result } from '../interfaces/result.interface'
import { API_URL } from '../services/token.service';

declare var $: any, dump: any, showSuccessMessage:any, showErrorMessage: any;

@Injectable()

export class _Ng1UserService {

  constructor(private http: HttpClient) { }

  GetCurrentUser(){
      return this.http.get<any>('/ajax/users/0').toPromise().then((result) => {
          return result;
      });
  }

}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/ng1-services/user.service.ts